export { default } from './dist/vue-google-charts.common'
export * from './dist/vue-google-charts.common'
// import './dist/vue-google-charts.css'



//////////////////
// WEBPACK FOOTER
// ./~/vue-google-charts/index.js
// module id = kXf/
// module chunks = 0